import React, { useState } from "react";
import PlaywrightTemplate from "./PlaywrightTemplate";

const PwCheckbox = () => {
  const [checked, setChecked] = useState(false);

  // additional languages state
  const languages = ["JavaScript", "Python", "Java", "C#", "Go", "Ruby"];
  const [langChecked, setLangChecked] = useState(
    languages.reduce((acc, lang) => ({ ...acc, [lang]: false }), {})
  );
  const toggleLang = (lang) => () =>
    setLangChecked((prev) => ({ ...prev, [lang]: !prev[lang] }));

  const sections = [
    {
      heading: "Checkbox Handling",
      ui: (
        <>
          <input
            type="checkbox"
            checked={checked}
            onChange={() => setChecked(!checked)}
          />
          <p>{checked ? "Checked" : "Unchecked"}</p>

          {/* programming languages list below */}
          <div style={{ marginTop: '20px' }}>
            {languages.map((lang) => (
              <div key={lang} style={{ marginBottom: '8px' }}>
                <input
                  type="checkbox"
                  className="lang-checkbox"
                  id={lang}
                  checked={langChecked[lang]}
                  onChange={toggleLang(lang)}
                />
                <label htmlFor={lang} style={{ marginLeft: '6px' }}>
                  {lang}
                </label>
              </div>
            ))}
            <p>
              Selected:{' '}
              {languages.filter((l) => langChecked[l]).join(', ') || 'none'}
            </p>
          </div>
        </>
      ),
      code: `// Check checkbox
await page.check('input[type="checkbox"]');

// Uncheck checkbox
await page.uncheck('input[type="checkbox"]');

// Verify checked
await expect(page.locator('input')).toBeChecked();`
    }
  ];

  return <PlaywrightTemplate title="CHECKBOX" sections={sections} />;
};

export default PwCheckbox;